import {NgModule} from '@angular/core';
import {PagesSharedModule} from '../../../pages/pages-shared.module';
import {FullDeviceComponent} from './full-device.component';
import {PdfJsViewerModule} from 'ng2-pdfjs-viewer';
import {FileModalComponent} from '../file-modal/file-modal.component';
import {FullDeviceOptionsComponent} from '../full-device-options/full-device-options.component';
import {NgxGraphModule} from '@swimlane/ngx-graph';
import {InventoryNumberInputModule} from '../../inputs/inventory-number-input/inventory-number-input.module';
import {BarcodeScannerModule} from '../../inputs/barcode-scanner/barcode-scanner.module';
import {CategorySelectModule} from '../../inputs/category-select/category-select.module';
import {DatabaseLookupInputModule} from '../../inputs/database-lookup-input/database-lookup-input.module';
import {SharedModule} from '../../../shared.modules';
import {OwnershipSelectModule} from '../../inputs/ownership-select/ownership-select.module';
import {SimpleSelectModule} from '../../inputs/base-select/simple-select/simple-select.module';
import {DateInputModule} from '../../inputs/date-input/date-input.module';
import {SearchFormModule} from '../../searchlist/search-form/search-form.module';
import {UrlnputModule} from '../../inputs/url-input/url-input.module';
import {DepartmentSelectModule} from '../../inputs/department-select/department-select.module';
import {PrintModalComponent} from '../print-modal/print-modal.component';
import {HistoryModalModule} from '../../history-modal/history-modal.module';
import {CategoryListModalModule} from '../../category-list-modal/category-list-modal.module';
import {TooltipModule} from 'angular-simple-tooltip';

@NgModule({
    imports: [
        SharedModule,
        PagesSharedModule,
        PdfJsViewerModule,
        NgxGraphModule,
        InventoryNumberInputModule,
        BarcodeScannerModule,
        SimpleSelectModule,
        CategorySelectModule,
        DepartmentSelectModule,
        DatabaseLookupInputModule,
        OwnershipSelectModule,
        DateInputModule,
        SearchFormModule,
        UrlnputModule,
        HistoryModalModule,
        CategoryListModalModule,
        TooltipModule
    ],
    declarations: [
        FullDeviceComponent,
        FileModalComponent,
        PrintModalComponent,
        FullDeviceOptionsComponent
    ],
    entryComponents: [
        FileModalComponent,
        PrintModalComponent
    ],
    exports: [
        FullDeviceComponent,
        FullDeviceOptionsComponent,
    ]
})
export class FullDeviceModule {
}
